import React from 'react';

import { cn } from '@/lib/utils';

import Button, { ButtonProps } from '@/components/atoms/button';

type IconButtonProps = {
  children: React.ReactNode;
} & ButtonProps;

// PS: 20px is padding (2x10px) + 24px/36px/48px is icon size
export const sizesOptions = ['s', 'm', 'l'] as const;
const sizes: Record<(typeof sizesOptions)[number], string> = {
  s: 'w-[32px] h-[32px]',
  m: 'w-[40px] h-[40px]',
  l: 'w-[48px] h-[48px]',
};
const paddings: Record<(typeof sizesOptions)[number], string> = {
  s: 'p-2',
  m: 'p-3',
  l: 'p-3',
};

/**
 * For it to work with SVG React component you need to remove width and height from SVG file like in IconDownload.svg
 * Be aware that after removing it you will need to set width and height where that svg is used across the app
 */
export function IconButton({ children, classNames, ...rest }: IconButtonProps) {
  return (
    <Button
      classNames={{
        root: cn(
          'h-auto',
          rest?.variant === 'text' &&
            'hover:bg-neutral-N04 rounded-full duration-300',
          paddings[rest?.size || 's'],
          sizes[rest?.size || 's'],
          classNames?.root
        ),
        inner: cn('h-full w-full', classNames?.inner),
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
